module.exports = __webpack_public_path__ + "static/media/bike.c2fdd678.svg";